import shouldSendSameSiteNone from "./same-site-cookie-detection";

const Utils = (function (utils) {
  // 1. get query string parameters
  let parameters = {};
  window.location.search
    .substr(1)
    .split("&")
    .forEach((p) => {
      var q = p.split("=");
      parameters[q[0]] = q[1];
    });

  // 2. compute base domain name and default cookie options
  const cookieDomain = location.hostname.split(".").splice(-2, 2).join(".");
  const bidKey = "virtusize.bid";
  const cookieTTL = 1; // in days
  const defaultCookieOptions = {
    expires: cookieTTL,
    path: "/",
    domain: cookieDomain,
  };
  const secure = location.protocol === "https:";

  // 3. set simple cookie to ensure that we can write cookies
  utils.writeCookie = function (key, value, options) {
    if (value !== undefined && typeof value !== "function") {
      options = { expires: 1, path: "/", ...options };

      if (typeof options.expires === "number") {
        var days = options.expires,
          t = (options.expires = new Date());
        t.setDate(t.getDate() + days);
      }

      return (document.cookie = [
        encodeURIComponent(key),
        "=",
        String(value),
        options.expires ? "; expires=" + options.expires.toUTCString() : "", // use expires attribute, max-age is not supported by IE
        options.path ? "; path=" + options.path : "",
        options.domain ? "; domain=" + options.domain : "",
        shouldSendSameSiteNone(navigator.userAgent) ? "; SameSite=None" : "",
        options.secure || secure ? "; secure" : "",
      ].join(""));
    }

    return null;
  };
  utils.writeCookie("virtusize.cookies_enabled", 1, defaultCookieOptions);

  // 4. parse cookies
  let cookies = {};
  document.cookie.split(";").forEach((c) => {
    var p = c.split("=");
    cookies[p[0].trim()] = p[1];
  });

  // 5. verify that writing was succesfull
  const cookiesDisabled = !cookies["virtusize.cookies_enabled"];

  // 6. check if there is a third party bid
  let bid = cookies[bidKey] || parameters["vs.bid"];
  const firstPartyBid = !cookies[bidKey];
  const widgetType =
    parameters["type"] ||
    (navigator && navigator.userAgent && navigator.userAgent.match(/mobi/i)
      ? "mobile"
      : "desktop");
  const origin = decodeURIComponent(
    parameters.origin || parameters.parentOrigin || ""
  );

  if (typeof bid === "undefined") {
    throw new Error("Undefined bid");
  }

  utils.fetch = function (data) {
    let method = data.method || "GET";
    let url = data.url;
    if (method === "GET") {
      url = `${url}?${data.data}`;
    }
    let request = new XMLHttpRequest();
    request.open(method, url, true);
    request.setRequestHeader(
      "Content-Type",
      `${data.contentType}; charset=UTF-8`
    );
    Object.keys(data.headers).forEach((entry) => {
      request.setRequestHeader(entry, data.headers[entry]);
    });

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        utils.postMessage(request.responseText);
      } else if (request.status >= 400) {
        utils.postMessage({ error: request.status });
      }
    };

    if (method === "POST") {
      request.send(data.data);
    } else {
      request.send();
    }
  };

  utils.createOrUpdateLocalStorageBid = function () {
    if (utils.hasLocalStorage() === true) {
      const lsBid = localStorage.getItem(bidKey);

      if (lsBid && lsBid != bid && firstPartyBid) {
        bid = lsBid;
        utils.writeCookie(bidKey, bid, defaultCookieOptions);
      } else {
        localStorage.setItem(bidKey, bid);
        utils.writeCookie(bidKey, bid, {
          ...defaultCookieOptions,
          expires: 180,
        });
      }
    }
  };

  utils.postEnvironmentCheck = function () {
    const visited = document.cookie.match(/virtusize.visited.(.*)=(.*);/);
    const event = {
      name: "util-checked-environment",
      data: {
        cookiesDisabled: cookiesDisabled,
        bid,
        widgetType,
        visited,
      },
    };
    utils.postMessage(JSON.stringify(event));
  };

  utils.postMessage = function (data) {
    parent.postMessage(data, origin);
  };

  utils.setupReceiveMessage = function () {
    window.addEventListener("message", function (e) {
      if (e.origin !== origin) {
        return false;
      }

      if (typeof e.data !== "undefined" && e.data !== null && e.data) {
        try {
          utils.receiveMessage(JSON.parse(e.data));
        } catch (err) {
          // Silently ignoring, since it could be an IE7 or some other
          // non-modern Browser and we want to show an error message
        }
      }
    });
  };

  utils.receiveMessage = function (message) {
    let mergedOptions = { ...defaultCookieOptions, ...(message.options || {}) };
    switch (message.name) {
      case "check-environment":
        Utils.postEnvironmentCheck();
        break;
      case "integration-called-backend":
        utils.fetch(utils.formatParameters(message));
        break;
      case "set-cookie":
        utils.writeCookie(
          `virtusize.visited.${message.typeName.toLowerCase()}`,
          message.value,
          mergedOptions
        );
        utils.postMessage(
          JSON.stringify({ name: "set-cookie", status: "success" })
        );
        break;
      case "integration-reset-bid":
        if (utils.hasLocalStorage() === true) {
          localStorage.removeItem(bidKey);
        }
        utils.writeCookie(bidKey, "", { domain: cookieDomain, expires: -1 });
        utils.writeCookie(bidKey, "", {
          domain: ".virtusize.com",
          expires: -1,
        });
        utils.writeCookie(bidKey, "", { domain: ".virtusize.jp", expires: -1 });
        utils.writeCookie(bidKey, "", { domain: ".virtusize.kr", expires: -1 });
        utils.fetch(utils.formatParameters(message));
        break;
    }
  };

  utils.formatParameters = function (parameters) {
    return {
      method: parameters.method || "GET",
      url: parameters.url,
      dataType: "text",
      contentType: parameters.contentType || "application/json",
      type: parameters.type,
      data: utils.formatEventData(parameters),
      headers: parameters.headers || { "X-VS-Bid": bid },
    };
  };

  utils.formatEventData = function (event) {
    if (event.method === "GET") {
      return Object.keys(event.data)
        .map((key) => key + "=" + encodeURIComponent(event.data[key]))
        .join("&");
    } else if (event.contentType === "application/json") {
      return JSON.stringify(event.data);
    } else if (event.contentType === "application/x-www-form-urlencoded") {
      return Object.keys(event.data)
        .map((key) => key + "=" + event.data[key])
        .join(";");
    }
    return event.data;
  };

  // From https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js
  utils.hasLocalStorage = function () {
    var test = "vsLocalStorageTest";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  return utils;
})({});

Utils.setupReceiveMessage();
Utils.createOrUpdateLocalStorageBid();
Utils.postEnvironmentCheck();
